import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=38cb6e2e&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"
import style0 from "./UserInfo.vue?vue&type=style&index=0&id=38cb6e2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../T88/build-source/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cb6e2e",
  null
  
)

export default component.exports